import { Text, Box } from '@mantine/core';

type TastePersonalityCardProps = {
  name: string | null;
  blurb: string | null;
  ownerName: string;
};

export const TastePersonalityCard = ({ name, blurb, ownerName }: TastePersonalityCardProps) => {
  if (!blurb) return null;

  return (
    <Box
      style={{
        flex: '1 1 300px',
        maxWidth: 550,
        padding: '12px 16px',
        borderRadius: 12,
        background: 'linear-gradient(to right, var(--mantine-color-gray-0) 70%, transparent)',
      }}
    >
      <Text size="sm" fw={700} c="violet.7" mb={4}>
        {name || `${ownerName}'s taste personality`}
      </Text>
      <Text
        size="xs"
        c="dimmed"
        lh={1.5}
        pl="sm"
        style={{
          fontStyle: 'italic',
          borderLeft: '3px solid var(--mantine-color-violet-3)',
        }}
      >
        {blurb}
      </Text>
    </Box>
  );
};
